export const environment = {
  url: 'http://localhost:4200',
  publicKeyToken: `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAzww1xl+KFftPm1D1s0/4
7QJrHtAZ1jtaKnbTjgWDaLglVStxxgjmRw9EacMNA5JwePVlsKDZ36aJEQFxJl8j
+h+4Ruh1iR2Y1i9DdD4PHUpVBrcEy159MS0ygMzO9jpvzih+/SXfJfM8mYKX+Ge2
TWBIiy+7mhDDjRMyVW4V04/inLft0iejrzF1iIUm0wjpsUePDMoDCfUHjro1U8gE
Fcn5xxC/+vDROjI3/DQPM0mw7ed77D8z7QJ9UfjLTBGGqZtcKdh6EQJxehRnPsd+
2JW9ytw0vD/b7yt2c5a3w5Nr1AAi2I3xwpBQ88psKvY6Epkh5Fht8XOSM19Evjv8
MeGvnlqVseSdRI9vNE9k10KKGE/xiz5smSAMfGRCYfQ+j8quc4Vho0HhFEOTIgCu
zb2yRaEkEdpfcEo+34Nd8bFQQgy3yapVqZcwHkY+9cOG+59XZHYV/onbs8u5Gd9Y
vzdz29cqVvwFUXMG/aDv2OehDFDTkr0Cb9wc2FqxF6Vb+yzooH9+Ymk7wM4OkQ7x
wEDtNZUeG/S3EF/8DHLHCGM9hpYS6Ux3eO0eZ7EFCaByTXJ4hFQnhen6v9IY/5zo
+NfS1iRRmjV9+asnP/90+YdHhZE1FJjaxOF4y+ucCeA0fAah2V5fK7MFXomVj0yj
2yA/DrxByBCxGbur59Fj4FUCAwEAAQ==
-----END PUBLIC KEY-----`,
  publicKeySeguridad: `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAvRiFI/6FUCmLnfudhh2e
I8gBJCtMQBvjOEtGaCT1mgY6YVbriEZL3XkyHNxFBUPMyvwyTOiOa1zOA1rwYHvh
GMW6QE2OFFsP35GFZ8KqMq3MBBo5u8f8tXtre59xXyoOf9ojlOSDIjcUU/SscDhk
8j4kub5OjaSPtM6rj627GhF9j/Vovoywu0ZM3R5w0W5SCiDw1+4RjnEm41m3Nxbb
3n+7yjFbvihpfEubfinW5dzMB8Lm+k86e5bCDbvG82bDtMJVlaw5tYYb/S8LAue3
FBVSX9qe/qv9aAsdeJyVsEJFsCSZ4MlS9kDVPlkLTXsHusQQ81n9nUeOco+QCM2y
qLifMZUBiRaClEjjKWrU/CfsRqGsAcHBzBKEAOc+/ZCdaLW6SG/KxxzA7OPX83UZ
WsZkuv55geVgG4SMAzOq6PJmgqEGCtR9Q4XZ+JO386M4WRA1he/P75YwEiypRGru
LbxdBjODFVC+f6S5rwKHH3dM3WloEXZmS/v9jl0aQIIdfxasj5QQvrAdnU0mCd24
RjRI4ceg5gmJHK4zOm4y767LTU54ioW5XBZDxL0h6YZCrIL/vaSEeCIATH2yYCF+
oLE6UsRkXQHm1kx2f7mflRa/Z/ARJPiBqyzhT8QiGVWRKN6ssGHJvnYtO4rOBQly
AWSpC6dlVOKQ2TMYOee4BBsCAwEAAQ==
-----END PUBLIC KEY-----`,
};
